import gql from 'graphql-tag';

import weightByRoleByIndustryFragment from './weightByRoleByIndustryFragment';

export const dictionaryDokkioLabelFragment = gql`
  fragment dictionaryDokkioLabelFragment on DictionaryDokkioLabel {
    dokkioClass
    name
    description
    icon
    dokkioTagType
    isMultiValue
    isBadgeDisplayed
    isNavDisplayed
    isPluralTagNames
    filterNotableOrganizationSuggestions
    filterNotablePersonSuggestions
    filterDokkioUserNameSuggestions
    synonyms
    weightByRoleByIndustry {
      ...weightByRoleByIndustryFragment
    }
  }
  ${weightByRoleByIndustryFragment}
`;
export default dictionaryDokkioLabelFragment;
